<template>
<!-- Container para toda la página: ******************************************************* -->

    <v-container fill-height fluid class="sign-in">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md5 lg4 elevation-6>
                <v-card class="elevation-12 pa-4" color="grey lighten-5" oncontextmenu="return false">
                    <v-card-text>
                        <v-container grid-list-sm>
                            <v-layout row justify-space-around>
                                <v-flex shrink>
                                    <img height="150" :src="logoAOCS" />
                                </v-flex>
                            </v-layout>
                            <p></p>
                            <v-layout row justify-center>
                                <v-flex shrink>
                                    <v-btn color="#ef4044" class="text-none" dark @click="onReEnter">
                                        Volver a abrir&nbsp;<v-icon>mdi-login</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <!-- Modal para informar que no se pudo iniciar la aplicación: *********************************** -->
                            <v-layout row justify-center>
                                <v-dialog v-model="failedLogin" persistent :width="errorModalWidth">
                                    <v-card class="grey lighten-4">
                                        <v-toolbar dense color="red darken-1" dark flat>
                                            <v-toolbar-title
                                                class="my-list-title"
                                            >Error</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-icon>mdi-alert-circle</v-icon>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12 class="d-flex justify-center">
                                                        <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center text-center"
                                                    >No se pudo iniciar la aplicación AOCs.</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="green darken-4"
                                                class="text-none"
                                                text
                                                @click="failedLogin = false"
                                            >OK</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>
                            <!-- Termina modal para informar que no se pudo iniciar la aplicación *********************************** -->

                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            <div>&copy; Grupo Tecnológico Santa Fe, S.A. de C.V. {{ new Date().getFullYear() }} &nbsp; v. {{ version }}</div>
        </v-footer>
        
    </v-container>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            
        };
    },
    created() {
    },
    components: {
    },
    methods: {
        onReEnter()
        {
            this.$store.dispatch('studentReEnter');
        },
    },
    computed: {
        ...mapGetters(['version','logoAOCS']),
        failedLogin: {
            get() {
                    return this.$store.getters.failedLogin;
            },
            set(failedLogin) {
                this.$store.dispatch('updateFailedLogin', failedLogin);
            },
        },
        
        waitCursor() {
            return this.$store.getters.waitCursor;
        },
         errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
    
};
</script>

<style scoped>
.sign-in {
    /* background: url('../assets/patiogallo1.jpg'); */
    background-color: #ef5350;
    background-size: cover;
    width: 100%;
    height: 100%;
}

.uia-red {
    color:#ef4044!important;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
